export const authRoles = {
  sa: ["SA", "REF"],
  admin: ["SA", "ADMIN", "SYSADMIN", "REF"],
  rootadmin: ["SYSADMIN"],
  ref: ["REF"],
  guest: ["SA", "ADMIN", "EDITOR", "GUEST"],
};
